var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"echarts"}},[_c('div',{staticClass:"wrap"},[_c('div',{ref:"pie",staticClass:"pie"}),_c('div',{ref:"bar",staticClass:"bar"})]),_c('div',{ref:"doubleBar",staticClass:"doubleBar"})])}
var staticRenderFns = []

export { render, staticRenderFns }